import { map, Subject, type Observable } from 'rxjs';

import { filterTruthy } from 'src/app/utils/functions/rx-filters';

export type Data<T> = Record<string, T>;

/**
 * Simple output emitter which is injectable with a token into a lazy loaded compoponent to communicate
 * to the client component (similar to @Output in a non lazy laoded compoennt).
 *
 * ℹ️ Currently this emitter is only used in this (price display) context, but could be reused (would then need to be moved).
 */
export class OutputEmitter<T = string> {
  private readonly subject: Subject<Data<T>> = new Subject<Data<T>>();

  public emit(output: string, value: T): void {
    this.subject.next({ [output]: value });
  }

  public register(output: string): Observable<T> {
    return this.subject.asObservable().pipe(
      map(data => data[output]),
      filterTruthy()
    );
  }
}
